<template>
  <div class="card events-card full-height">
    <div class="card-content">EstablishmentDetail</div>
  </div>
</template>

<script>
import settings from '@/settings.coffee'

export default {
  name: "EstablishmentDetail",
  props: {},
  computed: {}
};
</script>

<style lang="scss" scoped>
.pad {
  padding: 0;
  width: 100%;
  height: 100%;
}
</style>